import React from 'react';
import { Box, Text, Center, VStack, Icon } from '@chakra-ui/react';
import { LockIcon } from '@chakra-ui/icons';

export default function PermissionBlinder() {
  return (
    <Box position="relative" className='w-full h-[100vh] cursor-pointer gap-2 flex flex-col items-center justify-center' bg="gray.50">
          <Icon as={LockIcon} w={10} h={10} color="gray.700" />
          <Text fontSize="xl" fontWeight="bold" color="gray.700">
            Access Denied
          </Text>
          <Text fontSize="md" color="gray.600">
            You do not have permission to view this page.
          </Text>
    </Box>
  );
}
